import { AccessControlProvider } from '@skewb/access-control/react';
import type { ReactNode } from 'react';
import { useAccessControlPermissions } from '../hooks/useAccessControlApi';

interface AccessControlGateProps {
  children: ReactNode;
}

/**
 * Bridges the `getPermissions` query to AccessControlProvider, hydrating the
 * app-wide CASL ability from the current user's packed rules (deny-all until loaded).
 */
export function AccessControlGate({ children }: AccessControlGateProps) {
  const { data, isLoading } = useAccessControlPermissions();

  return (
    <AccessControlProvider rules={data?.rules} isLoading={isLoading}>
      {children}
    </AccessControlProvider>
  );
}
